<template>
    <span :class="classes">
        <i :class="indicatorClasses" aria-hidden="true"></i> {{ figure.replace('-', '') }}%
    </span>
</template>

<script>
    export default {
        props: {
            figure: {
                required: true,
            },

            isReversed: {
                default: false,
                type: Boolean,
            }
        },

        computed: {
            classes() {
                return {
                    'PercentageChange': true,
                    'PercentageChange--neutral': this.figure == 0,
                    'PercentageChange--positive': this.changeIsPositive,
                    'PercentageChange--negative': this.changeIsNegative
                }
            },

            indicatorClasses() {
                return {
                    'fa': true,
                    'fa-circle': this.figure.replace(',', '') == 0,
                    'fa-caret-up': this.figure.replace(',', '') > 0,
                    'fa-caret-down': this.figure.replace(',', '') < 0
                }
            },

            changeIsPositive() {
                let figure = this.figure.replace(',', '');

                if (! this.isReversed) {
                    return figure > 0;
                }

                return figure < 0;
            },

            changeIsNegative() {
                let figure = this.figure.replace(',', '');

                if (! this.isReversed) {
                    return figure < 0;
                }

                return figure > 0;
            }
        }
    }
</script>